import { ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'

import { BillStatus } from '@features/bills/enums/billStatus'
import { Bill } from '@features/bills/types/bill'
import { PaymentReconciliationModalWrapper } from '@features/paymentReconciliationModal'
import { SubjectReconciliationModalInner } from '@features/paymentReconciliationModal/elements/SubjectReconciliationModalInner'
import { useSubjectReconciliationSuggestions } from '@features/paymentReconciliationModal/hooks'

import { useFetchBills } from '../../routes/BillsList/legacy/hooks/useFetchBills'

export interface BillReconciliationModalProps extends ModalProps {
  subject: Bill
}

export const BillReconciliationModal = ({ subject, ...modalProps }: BillReconciliationModalProps): ReactElement => {
  const { bills, isLoading } = useFetchBills({
    contactId: subject?.contactId || '',
    currencyId: subject?.currencyId || undefined,
    status: BillStatus.Unpaid,
  })

  const { suggestions } = useSubjectReconciliationSuggestions(subject)

  return (
    <PaymentReconciliationModalWrapper<Bill>
      id={modalProps.id}
      currentSubject={subject}
      isLoading={isLoading}
      subjects={bills}
      suggestions={suggestions}
    >
      <SubjectReconciliationModalInner {...modalProps} subject={subject} />
    </PaymentReconciliationModalWrapper>
  )
}
